import runTransaction from "../../utils/runTransaction";

import contributorRoles from "../articles/constants/contributorRoles";

import updateWork from "./updateWork";

export default function addWorkNarrators(firebase, { users, production }, { transaction } = {}) {
	return runTransaction(
		firebase,
		[production.work?.ref],
		async (transaction, [work]) => {
			if (!work?.exists) {
				return;
			}

			const contributors = work.contributors || [];

			const hasOwnNarrator = contributors.some(
				({ role, productionId }) => role === contributorRoles.NARRATOR && productionId !== production.id,
			);

			if (!hasOwnNarrator) {
				await updateWork(
					firebase,
					{
						ref: work.ref,
						contributors: [
							...contributors.filter(({ productionId }) => productionId !== production.id),
							...users.map(({ firstName, lastName }) => ({
								role: contributorRoles.NARRATOR,
								lastName,
								firstName,
								productionId: production.id,
							})),
						],
					},
					{ transaction },
				);
			}
		},
		transaction,
	);
}
